import { createSelector } from 'reselect';

const sliceSelector = (state: any): any => state['router'];

export const querySelector = createSelector(sliceSelector, (slice: any) => (slice && slice.location ? slice.location.query : {}));
